import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { Global } from '../../../../../app.global';
import { Constants } from '../../../helper/constants';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'explain-question',
  templateUrl: './explain-question.component.html',
})
export class ExplainQuestionComponent implements OnInit {
  @Input() data: any;
  @Input() valueSelected: any;
  @Input() validationSelected: any;
  @Input() validationText: any;
  @Input() active: boolean;
  @Output() selectAnswer: EventEmitter<any> = new EventEmitter<any>();

  answers = [];
  validationList = [];

  constants = Constants;

  constructor(public global: Global) {}

  ngOnInit() {
    this.setAnswers();
    this.setValidationList();
  }

  setAnswers() {
    this.answers = [
      {
        id: '0',
        value: 'they are only valid in bays signposted ',
      },
      {
        id: '1',
        value: 'they are only valid in... (select below)',
      },
      {
        id: '2',
        value: 'use my own explanation (specify below)',
      },
      {
        id: '3',
        value: "don't explain",
      },
    ];
  }

  setValidationList() {
    this.validationList = [
      {
        id: '0',
        value: "bays signposted 'Business permit holders'",
      },
      {
        id: '1',
        value: "bays signposted 'Contract permit holders'",
      },
      {
        id: '2',
        value: "bays signposted 'Disc zone'",
      },
      {
        id: '3',
        value: "bays signposted 'Doctor permit holders'",
      },
      {
        id: '4',
        value: "bays signposted 'Market trader permit holders'",
      },
      {
        id: '5',
        value: "bays signposted 'Pay & Display'",
      },
      {
        id: '6',
        value: "bays signposted 'Resident permit holders'",
      },
      {
        id: '7',
        value: "bays signposted 'Season ticket holders'",
      },
      {
        id: '8',
        value: "bays signposted 'Visitor permit holders'",
      },
      {
        id: '9',
        value: "bays signposted 'Permit holders'",
      },
      {
        id: '10',
        value: 'bays where the signs say that they can be used',
      },
    ];
  }

  filteredValidations() {
    if (this.data.validList === undefined) {
      return this.validationList;
    }
    return this.validationList.filter(
      (validation) => this.data.validList.indexOf(validation.id) > -1
    );
  }

  onAnswerSelected() {
    if (!this.active) {
      return;
    }
    this.selectAnswer.emit({
      answerSelected: this.valueSelected,
      validationSelected: this.validationSelected,
      validationText: this.validationText,
    });
  }

  setValidationSelected(value) {
    this.validationSelected = parseInt(value, 10);
    this.onAnswerSelected();
  }

  setValueSelected(value) {
    if (!this.active) {
      return;
    }
    this.valueSelected = value;
    this.onAnswerSelected();
  }
}
